import React, { useState } from 'react'

interface PayloadViewerProps {
  content: string | null
  label: string
}

const tryFormatJson = (raw: string): string => {
  try {
    return JSON.stringify(JSON.parse(raw), null, 2)
  } catch {
    return raw
  }
}

export const PayloadViewer: React.FC<PayloadViewerProps> = ({ content, label }) => {
  const [copied, setCopied] = useState(false)

  if (!content) {
    return (
      <div>
        <div className='fw-bold mb-2'>{label}</div>
        <div className='text-muted fst-italic'>—</div>
      </div>
    )
  }

  const formatted = tryFormatJson(content)

  const handleCopy = () => {
    navigator.clipboard.writeText(formatted).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    })
  }

  return (
    <div>
      <div className='d-flex justify-content-between align-items-center mb-2'>
        <span className='fw-bold'>{label}</span>
        <button
          type='button'
          className='btn btn-sm btn-light-primary py-1 px-3'
          onClick={handleCopy}
        >
          {copied ? 'Скопировано' : 'Копировать'}
        </button>
      </div>
      <pre
        style={{
          fontFamily: 'monospace',
          fontSize: '0.8rem',
          background: 'var(--bs-secondary-bg)',
          border: '1px solid var(--bs-border-color)',
          borderRadius: '6px',
          padding: '12px',
          maxHeight: '300px',
          overflowY: 'auto',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all',
          margin: 0,
          color: 'var(--bs-body-color)',
        }}
      >
        {formatted}
      </pre>
    </div>
  )
}
